export default function htmlEncode(input) {
    if (typeof input !== 'string') {
        return input;
    }
    const encodedString = document.createElement('textarea');
    encodedString.textContent = input;
    return encodedString.innerHTML;
}
